import { CreateAccountPage } from '~/components/views/Signup/CreateAccountPage';

export default CreateAccountPage;
